/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `ferrous_metal` - ferrous_metal
* `fines` - fines
* `liquid` - liquid
* `non_metal` - non_metal
* `prohibitive` - prohibitive
* `clear_tray` - clear_tray
* `film` - film
* `non_food_grade` - non_food_grade
* `non_plastic` - non_plastic
* `pet_clear` - pet_clear
* `pet_clear_large` - pet_clear_large
* `pet_clear_full_sleeve` - pet_clear_full_sleeve
* `pet_light_blue` - pet_light_blue
* `pet_dark_blue` - pet_dark_blue
* `pet_green` - pet_green
* `pet_other` - pet_other
* `plastic_other` - plastic_other
* `aluminium_ubc` - aluminium_ubc
* `aluminium_foil_and_tray` - aluminium_foil_and_tray
* `aluminium_rigid_plastics` - aluminium_rigid_plastics
* `aluminium_vapes` - aluminium_vapes
* `aluminium_food_can` - aluminium_food_can
* `aluminium_other_aerosols` - aluminium_other_aerosols
* `aluminium_other` - aluminium_other
* `metal_other` - metal_other
* `aluminium_cast` - aluminium_cast
* `aluminium_foil_ubc` - aluminium_foil_ubc
* `aluminium_radiator` - aluminium_radiator
* `aluminium_tt` - aluminium_tt
* `aluminium_with_non_metal_attachments` - aluminium_with_non_metal_attachments
* `aluminium_with_iron_attachments` - aluminium_with_iron_attachments
* `aluminium_cast_with_iron_attachments` - aluminium_cast_with_iron_attachments
* `stainless_steel` - stainless_steel
* `total` - total
* `aluminium_packaging` - aluminium_packaging
* `copper_and_brass` - copper_and_brass
* `composite` - composite
* `non_ferrous_metal` - non_ferrous_metal
* `bulk_density` - bulk_density
* `intrinsic_viscosity` - intrinsic_viscosity
* `isophthalic_acid` - isophthalic_acid
* `melt_flow_rate` - melt_flow_rate
* `melting_point` - melting_point
* `other_impurities` - other_impurities
* `paper` - paper
* `particles_bt_5mm_10mm` - particles_bt_5mm_10mm
* `particles_bt_10mm_12mm` - particles_bt_10mm_12mm
* `particles_gt_12mm` - particles_gt_12mm
* `particles_lt_5mm` - particles_lt_5mm
* `pet_light_blue_flakes` - pet_light_blue_flakes
* `pet_dark_blue_flakes` - pet_dark_blue_flakes
* `pet_clear_flakes` - pet_clear_flakes
* `pet_colored_flakes` - pet_colored_flakes
* `pet_content` - pet_content
* `pet_flakes_non_ferrous_metal` - pet_flakes_non_ferrous_metal
* `pet_yellow_flakes` - pet_yellow_flakes
* `pet_green_flakes` - pet_green_flakes
* `ph` - ph
* `polyolefin_contamination` - polyolefin_contamination
* `pvc_contamination` - pvc_contamination
* `residual_contamination` - residual_contamination
* `residual_moisture` - residual_moisture
* `sampled_by` - sampled_by
* `wooden_materials` - wooden_materials
* `glue` - glue
* `corrugated_board` - corrugated_board
* `non_corrugated_board` - non_corrugated_board
* `other_fibre` - other_fibre
* `non_fibre` - non_fibre
 */
export type SampleCategories = typeof SampleCategories[keyof typeof SampleCategories];


export const SampleCategories = {
  ferrous_metal: 'ferrous_metal',
  fines: 'fines',
  liquid: 'liquid',
  non_metal: 'non_metal',
  prohibitive: 'prohibitive',
  clear_tray: 'clear_tray',
  film: 'film',
  non_food_grade: 'non_food_grade',
  non_plastic: 'non_plastic',
  pet_clear: 'pet_clear',
  pet_clear_large: 'pet_clear_large',
  pet_clear_full_sleeve: 'pet_clear_full_sleeve',
  pet_light_blue: 'pet_light_blue',
  pet_dark_blue: 'pet_dark_blue',
  pet_green: 'pet_green',
  pet_other: 'pet_other',
  plastic_other: 'plastic_other',
  aluminium_ubc: 'aluminium_ubc',
  aluminium_foil_and_tray: 'aluminium_foil_and_tray',
  aluminium_rigid_plastics: 'aluminium_rigid_plastics',
  aluminium_vapes: 'aluminium_vapes',
  aluminium_food_can: 'aluminium_food_can',
  aluminium_other_aerosols: 'aluminium_other_aerosols',
  aluminium_other: 'aluminium_other',
  metal_other: 'metal_other',
  aluminium_cast: 'aluminium_cast',
  aluminium_foil_ubc: 'aluminium_foil_ubc',
  aluminium_radiator: 'aluminium_radiator',
  aluminium_tt: 'aluminium_tt',
  aluminium_with_non_metal_attachments: 'aluminium_with_non_metal_attachments',
  aluminium_with_iron_attachments: 'aluminium_with_iron_attachments',
  aluminium_cast_with_iron_attachments: 'aluminium_cast_with_iron_attachments',
  stainless_steel: 'stainless_steel',
  total: 'total',
  aluminium_packaging: 'aluminium_packaging',
  copper_and_brass: 'copper_and_brass',
  composite: 'composite',
  non_ferrous_metal: 'non_ferrous_metal',
  bulk_density: 'bulk_density',
  intrinsic_viscosity: 'intrinsic_viscosity',
  isophthalic_acid: 'isophthalic_acid',
  melt_flow_rate: 'melt_flow_rate',
  melting_point: 'melting_point',
  other_impurities: 'other_impurities',
  paper: 'paper',
  particles_bt_5mm_10mm: 'particles_bt_5mm_10mm',
  particles_bt_10mm_12mm: 'particles_bt_10mm_12mm',
  particles_gt_12mm: 'particles_gt_12mm',
  particles_lt_5mm: 'particles_lt_5mm',
  pet_light_blue_flakes: 'pet_light_blue_flakes',
  pet_dark_blue_flakes: 'pet_dark_blue_flakes',
  pet_clear_flakes: 'pet_clear_flakes',
  pet_colored_flakes: 'pet_colored_flakes',
  pet_content: 'pet_content',
  pet_flakes_non_ferrous_metal: 'pet_flakes_non_ferrous_metal',
  pet_yellow_flakes: 'pet_yellow_flakes',
  pet_green_flakes: 'pet_green_flakes',
  ph: 'ph',
  polyolefin_contamination: 'polyolefin_contamination',
  pvc_contamination: 'pvc_contamination',
  residual_contamination: 'residual_contamination',
  residual_moisture: 'residual_moisture',
  sampled_by: 'sampled_by',
  wooden_materials: 'wooden_materials',
  glue: 'glue',
  corrugated_board: 'corrugated_board',
  non_corrugated_board: 'non_corrugated_board',
  other_fibre: 'other_fibre',
  non_fibre: 'non_fibre',
} as const;
